export default "__VITE_ASSET__HkgUz1R4__"